// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd1-cls1_XSx","cls2":"PodcastLibraryAd1-cls2_LFS PodcastLibraryAd1-cls1_XSx"};